export enum INFOCERT_FLOW_TYPE  {
    SINGLE = 'SINGLE',
    GROUP = 'GROUP',
    OFFICE = 'OFFICE'
} 